/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class GuaranteedRestoreTimeService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'GuaranteedRestoreTimeService\' loaded');
    }
}

export { GuaranteedRestoreTimeService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/GuaranteedRestoreTimeService.js